import { useEffect } from 'react';
import type {
  PaginatedData,
  OrganisationInteractingUserItem,
  OrganisationInteractingUserRequestParams,
  OptionalUrlTemplate,
  UrlTemplate,
} from 'src/apis/hydrogen-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';

type HookParams = {
  params: OrganisationInteractingUserRequestParams;
} & OptionalUrlTemplate;

type RequestParams = {
  params: OrganisationInteractingUserRequestParams;
} & UrlTemplate;

export function useHydrogenOrganisationInteractingUsers({
  url,
  params,
}: HookParams) {
  const request = useAxios(
    (axios, baseConfig, { url, params }: RequestParams) =>
      axios.request<PaginatedData<OrganisationInteractingUserItem>>({
        ...baseConfig,
        url,
        params,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!url) return;
    request.execute({ url, params });
    // oxlint-disable-next-line exhaustive-deps
  }, [url, params]);

  return request;
}

export type HydrogenOrganisationInteractingUsersRequest = ReturnType<
  typeof useHydrogenOrganisationInteractingUsers
>;
